import styled from '@emotion/styled';
import { ModalContainer, UIcon, IconContainer } from '../../Settings/Modal/CreateAdminUser';

const ViewDetails = (props: any) => {
  const data = props.data;

  return (
    <ModalContainer>
      <div>
        <div>
          <div>
            <IconContainer><UIcon /></IconContainer>
            <span>{data.ApplicantId}</span>
          </div>
        </div>
        <MainContainer>
          <div>
            <span>Full Name</span><span>{data?.ApplicantName}</span>
          </div>
          <div>
            <span>Email</span><span>{data?.ApplicantEmail}</span>
          </div>
          

          <div>
            <span>Phone Number</span><span>{data?.ApplicantPhone}</span>
          </div>
          
        </MainContainer>
      </div>
    </ModalContainer>
  )
}

export default ViewDetails

const MainContainer = styled.div`
  background-color: #fff;;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:20px;
  padding:30px;
  /* & > div:first-of-type > span:last-of-type{
    padding: 6px 10px;
    color:#11643C;
    background-color:#E0FAEE;
    border-radius: 3px;
  } */
  & > div{
    flex:1;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }

  & > div:last-child {
    gap: 350px;
    align-items: start;
    line-height: 2;

    & span {
      text-align: right;
      line-height: 2;
    }
  }
  
  & > div > span:first-of-type{
    color:#4E5A62;
  }
  
`